import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusquedasFotosObraComponent } from './components/busquedas-fotos-obra/busquedas-fotos-obra.component';
import { BusquedasAvanzadasComponent } from './components/busquedas-avanzadas/busquedas-avanzadas.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalleriaModule } from 'primeng/galleria';
import { FiltroFotosCapasComponent } from './components/filtro-fotos-capas/filtro-fotos-capas.component';
import { SliderModule } from 'primeng/slider';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgmCoreModule } from '@agm/core';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalGaleriaFotosComponent } from './components/modal-galeria-fotos/modal-galeria-fotos.component';
import { ModalReporteFotograficoComponent } from './components/modal-reporte-fotografico/modal-reporte-fotografico.component';
import { MultimediaComponent } from './components/shared/multimedia/multimedia.component';
@NgModule({
  declarations: [
    BusquedasFotosObraComponent,
    BusquedasAvanzadasComponent,
    FiltroFotosCapasComponent,
    ModalGaleriaFotosComponent,
    ModalReporteFotograficoComponent,
    MultimediaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule,
    GalleriaModule,
    SliderModule,
    SharedModule,
    CheckboxModule,
    NgbModule
  ],
  exports: [
    BusquedasFotosObraComponent,
    BusquedasAvanzadasComponent,
    ModalGaleriaFotosComponent,
    ModalReporteFotograficoComponent
  ]
})
export class BusquedasModule { }
